// import ImageOne from 'C:/Users/com/Desktop/homepage/homepage/src/images/쉐어플러그_01.svg';
import ImageTwo from '../../../images/쉐어플러그_02.png';
// import ImageThree from 'C:/Users/com/Desktop/homepage/homepage/src/images/쉐어플러그_03.svg';

import Icon1 from '../../../images/c-icon1.png';
import Icon2 from '../../../images/c-icon2.png';
import Icon3 from '../../../images/c-icon3.png';



export const ProblemSectionData = {
	id: 'about',
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: '쉐어플러그는 결제 이후 OTP를 입력해야 콘센트의 이용이 가능하기 때문에, 어떤 플러그도 도전 행위를 할 수 없습니다.',
	Icon1: Icon1,
  bolddes: '도전 행위를 원천적으로 차단합니다.',
	buttonLabel: 'Get started',
	imgStart: false,
	alt: 'car',
	dark: true,
	primary: true,
	darkText: false,

  topLine2: '주차 문제, 입주민간의 갈등, 모빌리티 이용 불가 등의 문제점을 해결하고 다양한 편의를 제공합니다.',
	Icon2: Icon2,
  bolddes2: '건물 이용객의 콘센트 이용에 편의를 제공합니다.',

  topLine3: '입주민을 위한 정기권을 사용할 수도있으며, 콘센트를 이용하는 고객이 늘어날수록 수익을 기대할 수 있습니다.',
	Icon3: Icon3,
  bolddes3: '추가적인 수익을 창출합니다.',

};


export const ContentSectionData = {
	id: 'about',
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: '전기 도둑 급증에 "차단 솔루션" 봇물',
	headLine: '언론',
  bolddes: '쉽게 콘센트를 사용할 수 있습니다.',
	buttonLabel: 'Get started',
	imgStart: false,
	alt: 'car',
	dark: true,
	primary: true,
	darkText: false,
  img2:ImageTwo,

  topLine2: '[CES 2021 ALL DIGITAL] 레인써클, 전기 공유콘센트 "쉐어 플러그" 소개',
	headLine2: 'icon2',
  bolddes2: '도전으로 의심받는 문제를 해결합니다.',

  topLine3: '[로그人] 정재웅 레인써클 대표 "잠금형 전기차 콘센트, 실증특례 발판삼아 …',
	headLine3: 'icon3',
  bolddes3: '다양한 전기 충전 문제를 해결합니다.',

};


export const PreFooterData = {
	id: 'about',
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: '전기 도둑 급증에 "차단 솔루션" 봇물',
	headLine: '언론',
  bolddes: '쉽게 콘센트를 사용할 수 있습니다.',
	buttonLabel: 'Get started',
	imgStart: false,
	alt: 'car',
	dark: true,
	primary: true,
	darkText: false,
  img2:ImageTwo,

  topLine2: '[CES 2021 ALL DIGITAL] 레인써클, 전기 공유콘센트 "쉐어 플러그" 소개',
	headLine2: 'icon2',
  bolddes2: '도전으로 의심받는 문제를 해결합니다.',

  topLine3: '[로그人] 정재웅 레인써클 대표 "잠금형 전기차 콘센트, 실증특례 발판삼아 …',
	headLine3: 'icon3',
  bolddes3: '다양한 전기 충전 문제를 해결합니다.',

};

